import { queryOptions } from '@tanstack/react-query';

import { apiUserProfileFetch } from '..';
import {
  AffiliationsViewDto,
  KycViewDto,
  PublicInvestmentsViewDto,
  QuestionnaireViewDto,
  RecordsViewDto,
  TransactionsViewDto,
  UserDocumentsViewDto,
  UserMainViewDto,
  UserOrganizationsViewDto,
  UserProfilePaginationParams,
  UserProfileViewDto,
} from './types';

export const USERS_PROFILE_QUERY_KEYS = {
  main: 'usersProfileMain',
  profile: 'usersProfileProfile',
  affiliations: 'usersProfileAffiliations',
  publicInvestments: 'usersProfilePublicInvestments',
  records: 'usersProfileRecords',
  kyc: 'usersProfileKyc',
  documents: 'usersProfileDocuments',
  transactions: 'usersProfileTransactions',
  questionnaire: 'usersProfileQuestionnaire',
  organizations: 'usersProfileOrganizations',
};

export const _getUserProfileMain = (userId?: string) => {
  return queryOptions({
    enabled: !!userId,
    queryKey: [USERS_PROFILE_QUERY_KEYS.main, userId],
    queryFn: () => apiUserProfileFetch<UserMainViewDto>(`/${userId}`),
    refetchOnMount: true,
    retry: 1,
  });
};

export const _getUserProfileProfile = (userId?: string) => {
  return queryOptions({
    enabled: !!userId,
    queryKey: [USERS_PROFILE_QUERY_KEYS.profile, userId],
    queryFn: () => apiUserProfileFetch<UserProfileViewDto>(`/${userId}/profile`),
    refetchOnMount: true,
    retry: 1,
  });
};

export const _getUserProfileAffiliations = (userId?: string) => {
  return queryOptions({
    enabled: !!userId,
    queryKey: [USERS_PROFILE_QUERY_KEYS.affiliations, userId],
    queryFn: () => apiUserProfileFetch<AffiliationsViewDto>(`/${userId}/affiliations`),
    refetchOnMount: true,
    retry: 1,
  });
};

export const _getUserProfilePublicInvestments = (
  userId?: string,
  params?: UserProfilePaginationParams,
) => {
  return queryOptions({
    enabled: !!userId,
    queryKey: [USERS_PROFILE_QUERY_KEYS.publicInvestments, userId, ...Object.values(params || {})],
    queryFn: () =>
      apiUserProfileFetch<PublicInvestmentsViewDto>(`/${userId}/public-investments`, {
        params,
      }),
    refetchOnMount: true,
    retry: 1,
  });
};

export const _getUserProfileRecords = (userId?: string, params?: UserProfilePaginationParams) => {
  return queryOptions({
    enabled: !!userId,
    queryKey: [USERS_PROFILE_QUERY_KEYS.records, userId, ...Object.values(params || {})],
    queryFn: () => apiUserProfileFetch<RecordsViewDto>(`/${userId}/records`, { params }),
    refetchOnMount: true,
    retry: 1,
  });
};

export const _getUserProfileKyc = (userId?: string) => {
  return queryOptions({
    enabled: !!userId,
    queryKey: [USERS_PROFILE_QUERY_KEYS.kyc, userId],
    queryFn: () => apiUserProfileFetch<KycViewDto>(`/${userId}/kyc`),
    refetchOnMount: true,
    retry: 1,
  });
};

export const _getUserProfileDocuments = (userId?: string) => {
  return queryOptions({
    enabled: !!userId,
    queryKey: [USERS_PROFILE_QUERY_KEYS.documents, userId],
    queryFn: () => apiUserProfileFetch<UserDocumentsViewDto>(`/${userId}/documents`),
    refetchOnMount: true,
    retry: 1,
  });
};

export const _getUserProfileTransactions = (
  userId?: string,
  params?: UserProfilePaginationParams,
) => {
  return queryOptions({
    enabled: !!userId,
    queryKey: [USERS_PROFILE_QUERY_KEYS.transactions, userId, ...Object.values(params || {})],
    queryFn: () => apiUserProfileFetch<TransactionsViewDto>(`/${userId}/transactions`, { params }),
    refetchOnMount: true,
    retry: 1,
  });
};

export const _getUserQuestionnaire = (userId?: string) => {
  return queryOptions({
    enabled: !!userId,
    queryKey: [USERS_PROFILE_QUERY_KEYS.questionnaire, userId],
    queryFn: () => apiUserProfileFetch<QuestionnaireViewDto>(`/${userId}/questionnaire`),
    refetchOnMount: true,
    retry: 1,
  });
};

export const _getUserProfileOrganizations = (userId?: string) => {
  return queryOptions({
    enabled: !!userId,
    queryKey: [USERS_PROFILE_QUERY_KEYS.organizations, userId],
    queryFn: () => apiUserProfileFetch<UserOrganizationsViewDto>(`/${userId}/organizations`),
    refetchOnMount: true,
    retry: 1,
  });
};
